import { PREFIX_SCM_PATH } from "../constant/path";

export const NETWORK_API = {
  urlCartList: `${PREFIX_SCM_PATH}/networks`,
};
